import React from 'react';
import { observer } from 'mobx-react-lite';
import {
  BetNotificationWr,
  SlowConnectionWr,
  ConnectionPopupsWr,
  UnderMaintenanceWr,
  useTranslation,
} from '@pascal/pascal-core';
import 'rc-slider/assets/index.css';
import { doBetStore } from '../../../store';
import Game from '../../../components/common/game';
// import logoimg from '../../../assets/images/logo.png';

const GameWr = observer(() => {
  const { isDisabled } = doBetStore.betData;
  const t = useTranslation();

  return (
    <div className='striker-game-wrapper'>
      <div className='striker-game-holder'>
        <Game t={t} isShowBetsClosingPopUp={isDisabled} />
      </div>
      <BetNotificationWr />
      <UnderMaintenanceWr />
      <SlowConnectionWr />
      <ConnectionPopupsWr />
      {/* <div className='tournament-block'> */}
      {/*  <button type='button' className='tournament-btn'> */}
      {/*    <img src={logoimg} alt='' /> */}
      {/*  </button> */}
      {/* </div> */}
    </div>
  );
});

export default GameWr;
